var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"4"}},[_c('amplify-authenticator',{attrs:{"authConfig":_vm.authConfig}},[_c('amplify-sign-in',{attrs:{"slot":"sign-in","hide-sign-up":"true"},slot:"sign-in"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }